import React, { PureComponent } from 'react';
import {
	Dialog as BaseDialog,
	DialogSurface,
	DialogHeader,
	DialogHeaderTitle,
	DialogBody,
	DialogFooter,
	DialogFooterButton,
	DialogBackdrop
} from 'rmwc/Dialog';
import { FormattedMessage, injectIntl } from "react-intl";
import styled from 'styled-components';
import { PreventEvents } from "./Layout";
import Sizes from "../Assets/Sizes";

const Dialog = styled(BaseDialog)`
  direction: ${ p => p.ltr };
`;

const MyDialogFooter = styled(DialogFooter)`
  direction: ${ p => p.ltr };
  --mdc-theme-primary: ${ p => p.theme.colors.modalPrimaryColor };

  button:not(:last-of-type) {
    margin-left: ${ Sizes.smallMargin };
  }

  button:not(:first-of-type) {
    margin-right: ${ Sizes.smallMargin };
  }
`;


class Confirm extends PureComponent {
	state = {
		visible: false,
		visibleDialog: false
	};

	constructor(props) {
		super(props);
		injectIntl(this);
	}

	show(title, body, actionHandler) {
		this.setState({
			render: true,
			title,
			body,
			actionHandler
		}, () => {
			setTimeout(() => {
				this.setState({
					visibleDialog: true
				})
			})

		})
	}

	hide(confirm) {
		let preventHiding = false;
		if (this.state.actionHandler) {
			preventHiding = this.state.actionHandler(confirm);
		}

		if (preventHiding) {
			return;
		}

		this.setState({
			visibleDialog: false
		}, () => {
			setTimeout(() => {
				this.setState({
					render: false
				})
			}, 500);

		})
	};

	render() {
		const { title, body } = this.state;
		const ltr = this.props.ltr;
		const strLtr = ltr ? 'ltr' : 'rtl';

		return (
			<div>
				{ this.state.render &&
					<Dialog
						ltr={ strLtr }
						open={ this.state.visibleDialog }
						onClose={ evt => this.hide() }
					>
						<DialogSurface>
							<DialogHeader color="black">
								<DialogHeaderTitle>{ title }</DialogHeaderTitle>
							</DialogHeader>
							<DialogBody>
								{ body }
								{ this.props.children }
							</DialogBody>
							<MyDialogFooter ltr={ strLtr }>
								<DialogFooterButton onClick={ () => this.hide() }><PreventEvents><FormattedMessage
									id={ this.props.cancelMessageId || "app.cancel" }/></PreventEvents></DialogFooterButton>
								<DialogFooterButton raised disabled={ !!this.props.disabled }
													onClick={ () => this.hide(true) }
								><PreventEvents><FormattedMessage
									id={ this.props.confirmMessageId || "app.yes" }/></PreventEvents></DialogFooterButton>
							</MyDialogFooter>
						</DialogSurface>
						<DialogBackdrop/>
					</Dialog>
				}
			</div>
		);
	}

}

export default Confirm;

